export const pick = (obj, keys) => {
  return keys.reduce((result, key) => {
    if (key in obj) {
      result[key] = obj[key];
    }
    return result;
  }, {});
};

export function toUnixSeconds(ts) {
  if (ts == null) return null;
  const n = Number(ts);
  if (Number.isNaN(n)) return null;
  const len = String(Math.trunc(Math.abs(n))).length;
  if (len >= 13) return Math.floor(n / 1000);
  return Math.floor(n);
}

export function convertToPairs(series = [], options = {}) {
  const {
    valueKey = 'nav',
    sort = 'asc',
    skipInvalid = true,
    valueTransform = (v) => (v == null ? null : Number(v)),
  } = options;

  const pairs = series.map((item) => {
    const tsSec = toUnixSeconds(item.nav_time ?? item.timestamp ?? item.time);
    const val = valueTransform(item[valueKey], item);
    return { raw: item, ts: tsSec, value: Number.isFinite(val) ? val : null };
  });

  const filtered = skipInvalid
    ? pairs.filter((p) => p.ts !== null && Number.isFinite(p.value))
    : pairs;

  const arrayPairs = filtered.map((p) => [p.ts, p.value]);

  if (sort === 'asc') {
    arrayPairs.sort((a, b) => a[0] - b[0]);
  } else if (sort === 'desc') {
    arrayPairs.sort((a, b) => b[0] - a[0]);
  }

  return arrayPairs;
}

